import wishlistHeaderFriendsSection from "../../components/wishlistHeaderFriendsSection/index.vue";
import wishlistHeaderSection from "../../components/wishlistHeaderSection/index.vue";
import wishlistAboutSection from "../../components/wishlistAboutSection/index.vue";

import axios from "axios";
export default {
  name: "wishlistArticleSection",
  components: {
    wishlistHeaderFriendsSection,
    wishlistHeaderSection,
    wishlistAboutSection,
  },
  data() {
    return {
      articleNumber: false,
      ArticlesWhishlist: [],
      ActiveUserId: "",
      modelDescription: "",
      modelPrice: "",
      modelTitle: "",
      modelImage1: "",
      modelImage2: "",
      modelImage3: "",
      friendList: [],
      modelImage0: "",
      colorImg: "",
      allArticles: [],
      currentPage: 1,
      productUser: [],
      picNumber: 0,
      sortedData: [],
      selectedFilters: [],
      dataToFilter: [],
      FilterAll: "",
      modelDisponible: "",
      quantiteMax: 1,
      quantiteMin: 1,
      btnValue: "",
      selectDetailsSize: "",
      detailsElement: [],
      detailsElementSize: [],
      detailsElementPointure: [],
      detailsElementDimmension: [],
      dimmensionLargeur: 0,
      dimmensionLongueur: 0,
      maxW: 0,
      maxH: 0,
      idSelectedElement: "",
      // sizeProduct:["x","y"],
      model: {
        quantite: 1,
      },
    };
  },
  async created() {
    this.wishlist();
    var userId = {
      userId: window.localStorage.getItem("Giftstore-U"),
    };
    axios
      .post(
        "https://giftstore-blog.herokuapp.com/api/user/friend/getFriendList",
        userId
      )
      .then((response) => {
        console.log("1478526ô", response);
        this.friendList = response.data.friendList;
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  },
  methods: {
    wishlistType() {
      if (
        this.$route.query.idActive == window.localStorage.getItem("Giftstore-U")
      ) {
        return true;
      } else {
        return false;
      }
    },
    UserName(firstName, lastName) {
      return firstName + " " + lastName;
    },
    linkFriend(id) {
      return "/wishlist-friend?idActive=" + id;
    },
    activeUserId() {
      this.$store.commit("setActiveUser", this.$route.query.idActive);
      this.wishlist();
    },
    async wishlist() {
      var userId = {
        user: this.$route.query.idActive,
      };
      await axios
        .post(
          "https://giftstore-blog.herokuapp.com/api/user/wishlist/fetch",
          userId
        )
        .then((response) => {
          this.ArticlesWhishlist = response.data.wishlist.wishList;
          console.log("wishlist", this.ArticlesWhishlist);
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
      if (this.ArticlesWhishlist.length == 0) {
        this.articleNumber = true;
        this.$toast.open({
          message: "Aucun articles dans cette wishlist",
          type: "info",
        });
      }
    },
    deleteWishlist(id) {
      var product = {
        user: window.localStorage.getItem("Giftstore-U"),
        product: id,
      };
      axios
        .post(
          "https://giftstore-blog.herokuapp.com/api/user/wishlist/remove",
          product
        )
        .then((response) => {
          this.$store.commit("setUserInfo", response.data);
          this.wishlist();
          this.$toast.open({
            message: "Produit bien supprimé de la wishlist ",
            type: "success",
            // position: "top-right",
            // all of other options may go here
          });
        })
        .catch((error) => {
          console.error("There was an error!", error);
          this.$toast.open({
            message: "Error lors de la suppression du produit",
            type: "error",
            // position: "top-right",
            // all of other options may go here
          });
        });
    },
    WishlistImage(element) {
      if (element.typeArticle == "vetements") {
        return (
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" + element.vetements[0].image[0]
        );
      } else if (element.typeArticle == "chaussure") {
        return (
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" + element.chaussure[0].image[0]
        );
      } else if (element.typeArticle == "tapis") {
        return (
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" + element.tapis[0].image[0]
        );
      }else if (element.typeArticle == "autre") {
        return (
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" + element.autre[0].image[0]
        );
      }
     
    },
    modelContent(element, index) {
      this.idSelectedElement = element._id;
      this.detailsElement = element;
      if (this.detailsElement.typeArticle == "vetements") {
        this.colorImg = element.vetements[0].couleur;
        this.selectDetailsSize =
          element.vetements[0].tailleEtQuantites[0].taille;
        this.detailsElementSize = element.vetements[0].tailleEtQuantites;
        this.quantiteMax = element.vetements[0].tailleEtQuantites[0].quantite;
        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.vetements[0].image[0];
        this.modelImage1 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.vetements[0].image[0];
        this.modelImage2 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.vetements[0].image[1];
        this.modelImage3 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.vetements[0].image[2];

        if (element.disponibility) {
          if (
            new Date(element.disponibility[0]) > new Date() ||
            element.vetements[0].tailleEtQuantites[0].quantite <= 0
          ) {
            this.modelDisponible = "Précommander";
          } else {
            this.modelDisponible = "Disponible";
          }
        } else if (element.vetements[0].tailleEtQuantites[0].quantite > 0) {
          this.modelDisponible = "Disponible";
        }
      } else if (this.detailsElement.typeArticle == "chaussure") {
        this.colorImg = element.chaussure[0].couleur;
        this.selectDetailsPointure =
          element.chaussure[0].pointureEtQuantites[0].pointure;
        this.detailsElementPointure = element.chaussure[0].pointureEtQuantites;
        this.quantiteMax = element.chaussure[0].pointureEtQuantites[0].quantite;

        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.chaussure[0].image[0];
        this.modelImage1 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.chaussure[0].image[0];
        this.modelImage2 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.chaussure[0].image[1];
        this.modelImage3 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.chaussure[0].image[2];

        if (element.disponibility) {
          if (
            new Date(element.disponibility[0]) > new Date() ||
            element.chaussure[0].pointureEtQuantites[0].quantite <= 0
          ) {
            this.modelDisponible = "Précommander";
          } else {
            this.modelDisponible = "Disponible";
          }
        } else if (element.chaussure[0].pointureEtQuantites[0].quantite > 0) {
          this.modelDisponible = "Disponible";
        }
      } else if (this.detailsElement.typeArticle == "tapis") {
        this.colorImg = element.tapis[0].couleur;
        this.detailsElementDimmension = this.detailsElement.tapis[0].widthAndHeight;
        this.maxH = this.detailsElementDimmension[0].heightMax;
        this.maxW = this.detailsElementDimmension[0].widthMax;
        this.selectDetailsPointure =
          element.tapis[0].widthAndHeight[0].pointure;
        this.detailsElementPointure = element.tapis[0].widthAndHeight;
        this.quantiteMax = element.tapis[0].widthAndHeight[0].quantite;

        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.tapis[0].image[0];
        this.modelImage1 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.tapis[0].image[0];
        this.modelImage2 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.tapis[0].image[1];
        this.modelImage3 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.tapis[0].image[2];

        if (element.disponibility) {
          if (
            new Date(element.disponibility[0]) > new Date() ||
            element.tapis[0].widthAndHeight[0].quantite <= 0
          ) {
            this.modelDisponible = "Précommander";
          } else {
            this.modelDisponible = "Disponible";
          }
        } else if (element.tapis[0].widthAndHeight[0].quantite > 0) {
          this.modelDisponible = "Disponible";
        }
      } else if (this.detailsElement.typeArticle == "autre") {
        this.colorImg = element.autre[0].couleur;

        this.selectDetailsPointure = element.autre[0].quantites[0].pointure;
        this.detailsElementPointure = element.autre[0].quantites;
        this.quantiteMax = element.autre[0].quantites[0].quantite;

        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.autre[0].image[0];
        this.modelImage1 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.autre[0].image[0];
        this.modelImage2 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.autre[0].image[1];
        this.modelImage3 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.autre[0].image[2];

        if (element.disponibility) {
          if (
            new Date(element.disponibility[0]) > new Date() ||
            element.autre[0].quantites[0].quantite <= 0
          ) {
            this.modelDisponible = "Précommander";
          } else {
            this.modelDisponible = "Disponible";
          }
        } else if (element.autre[0].quantites[0].quantite > 0) {
          this.modelDisponible = "Disponible";
        }
      }

      this.modelDescription = element.description;
      this.modelPrice = this.numberWithSpaces(element.productPrice);
      // this.modelPrice=element.price
      this.modelTitle = element.label;
      this.btnValue = element.orderType;
    },
    imgColor(img) {
      return (
        "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" + img
      );
    },
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    GetProductNumber() {
      //extracting the theme number from local storage
      if (localStorage.getItem("ProductNumber") === null) {
        return 0;
      } else {
        return localStorage.getItem("ProductNumber");
      }
    },
    addedElement(id) {
      var ProNum = this.GetProductNumber();
      var idElement;
      for (let i = 1; i <= ProNum; i++) {
        idElement = JSON.parse(localStorage.getItem("product" + i));
        if (idElement.id == id) {
          return false;
        }
      }
      return true;
    },
    addedwhislit(id) {
      // if (this.$store.getters.getUserInfo.wishList != "undefined") {
      //   this.$store.getters.getUserInfo.wishList.forEach(element => {
      //     if(element._id==id){
      //       return true
      //     }
      //     return false
      //   });
      // }
    },
    changeDetailProduct(element, index) {
      this.colorImg = element.couleur;
      this.getImage(element.image[0]);
      console.log(index);
      if (this.detailsElement.typeArticle == "vetements") {
        this.detailsElementSize = this.detailsElement.vetements[
          index
        ].tailleEtQuantites;
      } else if (this.detailsElement.typeArticle == "chaussure") {
        this.detailsElementPointure = this.detailsElement.chaussure[
          index
        ].pointureEtQuantites;
      } else if (this.detailsElement.typeArticle == "tapis") {
        this.detailsElementDimmension = this.detailsElement.tapis[
          index
        ].widthAndHeight;
        this.maxH = this.detailsElementDimmension[0].heightMax;
        this.maxW = this.detailsElementDimmension[0].widthMax;
        if (this.detailsElementDimmension[0].quantite == 0) {
          this.quantiteMax = 0;
          this.quantiteMin = 0;
        } else {
          this.quantiteMax = this.detailsElementDimmension[0].quantite;
        }
      } else if (this.detailsElement.typeArticle == "autre") {
        this.detailsElementDimmension = this.detailsElement.autre[
          index
        ].quantites;
        if (this.detailsElementDimmension[0].quantite == 0) {
          this.quantiteMax = 0;
          this.quantiteMin = 0;
        } else {
          this.quantiteMax = this.detailsElementDimmension[0].quantite;
        }
      }
    },
    getImage(img) {
      console.log(this);
      if (
        img.includes(
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/"
        )
      ) {
        this.modelImage0 = img;
      } else {
        this.modelImage0 =
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          img;
      }
    },
    deleteArticle(id) {
      var TabThemes = [];
      var nb = this.GetProductNumber();
      window.localStorage.removeItem("ProductNumber");
      var idElement;
      for (var k = 1; k <= nb; k++) {
        idElement = JSON.parse(localStorage.getItem("product" + k));
        if (idElement.id != id) {
          TabThemes.push(JSON.stringify(idElement));
        }
        window.localStorage.removeItem("product" + k);
      }
      for (var j = 1; j <= TabThemes.length; j++) {
        localStorage.setItem("product" + j, TabThemes[j - 1]);
      }
      localStorage.setItem("ProductNumber", TabThemes.length);
      this.getElements();
      this.$toast.open({
        message: "Produit supprimé au Panier",
        type: "success",
      });
      this.$store.commit("setbasket", TabThemes);
    },
    addArticle(id) {
      let ProNum = this.GetProductNumber();
      var TabThemes = [];
      ProNum++;
      var product;
      if (this.detailsElement.typeArticle == "vetements") {
        product = {
          nb: this.model.quantite,
          taille: this.selectDetailsSize,
          couleur: this.colorImg,
          id: id,
        };
      } else if (this.detailsElement.typeArticle == "chaussure") {
        product = {
          nb: this.model.quantite,
          pointure: this.selectDetailsPointure,
          couleur: this.colorImg,
          id: id,
        };
      } else if (this.detailsElement.typeArticle == "tapis") {
        product = {
          nb: this.model.quantite,
          largeur: this.dimmensionLargeur,
          longueur: this.dimmensionLongueur,
          couleur: this.colorImg,
          id: id,
        };
      } else if (this.detailsElement.typeArticle == "autre") {
        product = {
          nb: this.model.quantite,
          couleur: this.colorImg,
          id: id,
        };
      }
      localStorage.setItem("ProductNumber", ProNum);
      localStorage.setItem("product" + ProNum, JSON.stringify(product));
      console.log(
        "object",
        JSON.parse(localStorage.getItem("product" + ProNum))
      );
      this.getElements();
      this.$toast.open({
        message: "Produit bien ajouté au Panier",
        type: "success",
      });
      for (var k = 1; k <= ProNum; k++) {
        TabThemes.push(localStorage.getItem("product" + k));
      }
      this.$store.commit("setbasket", TabThemes);
    },
    addWishlist(id) {
      var product = {
        user: window.localStorage.getItem("Giftstore-U"),
        product: id,
      };
      if (window.localStorage.getItem("Giftstore-U")) {
        axios
          .post(
            "https://giftstore-blog.herokuapp.com/api/user/wishlist/add",
            product
          )
          .then((response) => {
            this.$store.commit("setUserInfo", response.data.user);
            console.log(response);
            this.wishlist();
            this.$toast.open({
              message: "Produit bien ajouté à la wishlist",
              type: "success",
              // position: "top-right",
              // all of other options may go here
            });
          })
          .catch((error) => {
            console.error("There was an error!", error);
            this.$toast.open({
              message: "Error lors de l'ajout du produit",
              type: "error",
              // position: "top-right",
              // all of other options may go here
            });
          });
      } else {
        this.$toast.open({
          message: "Vous devez être connecter",
          type: "info",
        });
      }
    },
  },
};
